var map = {
	"./collapse.png": "7f1d",
	"./config.png": "6640",
	"./contents.png": "7865",
	"./customers.png": "28d6",
	"./expand.png": "745c",
	"./home.png": "4ecb",
	"./maintenance.png": "9047",
	"./statistics.png": "ad79",
	"./support.png": "8427",
	"./treatments.png": "656e",
	"./users.png": "4bd8",
	"./white/config.png": "b214",
	"./white/contents.png": "2ae0",
	"./white/customers.png": "efee",
	"./white/home.png": "3cff",
	"./white/maintenance.png": "a95d",
	"./white/statistics.png": "c61b",
	"./white/support.png": "070b",
	"./white/treatments.png": "a744",
	"./white/users.png": "c7fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c13";